/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSocietySocietyFormsInner
 */
export interface AdminSocietySocietyFormsInner {
    /**
     * 
     * @type {string}
     * @memberof AdminSocietySocietyFormsInner
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSocietySocietyFormsInner
     */
    internalIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSocietySocietyFormsInner
     */
    readableName: string;
    /**
     * JSON list of fields
     * @type {object}
     * @memberof AdminSocietySocietyFormsInner
     */
    fieldsList?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AdminSocietySocietyFormsInner
     */
    readonly prepopulatedData?: object;
}

/**
 * Check if a given object implements the AdminSocietySocietyFormsInner interface.
 */
export function instanceOfAdminSocietySocietyFormsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;

    return isInstance;
}

export function AdminSocietySocietyFormsInnerFromJSON(json: any): AdminSocietySocietyFormsInner {
    return AdminSocietySocietyFormsInnerFromJSONTyped(json, false);
}

export function AdminSocietySocietyFormsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSocietySocietyFormsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalIdentifier': json['internal_identifier'],
        'readableName': json['readable_name'],
        'fieldsList': !exists(json, 'fields_list') ? undefined : json['fields_list'],
        'prepopulatedData': !exists(json, 'prepopulated_data') ? undefined : json['prepopulated_data'],
    };
}

export function AdminSocietySocietyFormsInnerToJSON(value?: AdminSocietySocietyFormsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internal_identifier': value.internalIdentifier,
        'readable_name': value.readableName,
        'fields_list': value.fieldsList,
    };
}

